<template>
  <section class="container-fluid my-4">
    <h4 class="my-4">Criando <strong>Histórico</strong></h4>

    <div v-if="item">
      <form>
        <div class="row">
          
          <div class="form-group col-md-12">
            <label for="name">Aluno</label>
            <input
              readonly
              type="text"
              class="form-control"
              id="name"
              v-model="item.name"
            />
          </div>
        </div>
        <div class="row">

          <div class="form-group col-md-2">
            <label>Modelo do Documento:</label>
            <select v-model="selectedTemplateId" class="form-control">
              <option disabled value="" selected>-- Selecione --</option>
              <option
                v-for="(tpl, index) in documentTemplates"
                :key="index"
                :value="tpl.id"
              >
                {{ tpl.name }}
              </option>
            </select>
          </div>

          <div class="form-group col-md-2">
            <label for="name">Turmas</label>
            <select id="team" class="form-control" @change="getFullGrid">
              <option disabled value="" selected>-- Selecione --</option>
              <option v-for="registration in registrations" :key="registration.team.id" :value="registration.team.id" :data-matricula="registration.id">
                {{ registration.team.name | uppercase }}
              </option>
            </select>

          </div>

          <div class="form-group col-md-2">
            <label for="name">Cidade</label>
            <input
              type="text"
              name="city"
              v-model="city"
              class="form-control"
            />
          </div>

          <div class="form-group col-md-1">
            <label for="name">Estado</label>
            <input type="text" name="uf" v-model="uf" class="form-control" />
          </div>

          <div class="form-group col-md-1">
            <label for="name">Dia</label>
            <input
              type="text"
              maxlength="2"
              name="uf"
              v-model="day"
              @keyup="filterNonNumeric"
              class="form-control"
            />
          </div>

          <div class="form-group col-md-2">
            <label for="name">Mês</label>

            <select id="month" class="form-control" v-model="month">
              <option disabled value="" selected>-- Selecione --</option>
              <option v-for="(name, index) in months" :key="index">
                {{ name }}
              </option>
            </select>

          </div>

          <div class="form-group col-md-1">
            <label for="name">Ano</label>
            <input
              type="text"
              maxlength="4"
              name="uf"
              v-model="year"
              @keyup="filterNonNumeric"
              class="form-control"
            />
          </div>

          <div class="form-group col-md-1">
            <label for="media">Média</label>
            <select id="media" name="media" v-model="media" class="form-control">
              <option disabled value="">--</option>
              <option
                v-for="option in mediaOptions"
                :key="option"
                :value="option"
              >
                {{ option }}
              </option>
            </select>
          </div>       

        </div>

        <div class="row">
          <div class="form-group col-md-12">
            <label><strong style="color:#0d6efd">OBSERVAÇÃO:</strong></label>
            <textarea
              rows="3"
              class="form-control form-control-sm mt-1"
              v-model="observation"
              placeholder="Deixe em branco se não houver observação."
            ></textarea>
          </div>
        </div>

      </form>

    </div>
    <LoadingPage v-else />
    <!-- Lista grade para ser preenchida -->

    <transition>
      <div v-if="isObjectEmpty">
        <hr />
        <div class="pdfContent">
          <div class="historyHeader">
            <p>NOME: {{ item.name }}</p>
            <p>MÃE: {{ item.name_mother }}</p>
            <p>NATURALIDADE: {{ item.naturalness }}</p>
            <p>DATA &nbsp;DE NASCIMENTO: {{ item.birth_date }}</p>
            <p>CPF: {{ cpfWithMask(item.cpf) }}</p>
            <span class="code" title="Código de segurança para validação do documento. A cada atualização da página esse valor altera.">Código de validação: {{ code }}</span>
          </div>

          <p class="text-center">
            <b>{{ courseName | uppercase }}</b>
          </p> 

          <form ref="formHistoric" @submit.prevent="saveGrades">

            <table class="table table-bordered">
              <thead>
                <tr>
                  <th
                    rowspan="2"
                    style="text-align: center; vertical-align: middle; width: 45%;"
                  >
                    DISCIPLINA
                  </th>
                  <th :colspan="(totalStage * 2)" style="text-align: center">
                    RESULTADO FINAL
                  </th>
                </tr>

                <tr>

                  <template v-for="(stage) in rangeStage" >

                    <!-- eslint-disable-next-line vue/require-v-for-key -->
                    <th style="text-align: center; white-space: nowrap" > C/H TOTAL </th>

                    <!-- eslint-disable-next-line vue/require-v-for-key -->
                    <th style="text-align: center; white-space: nowrap" > ETAPA {{ stage }} </th>

                  </template>
                
                </tr>

              </thead>

              <tbody>
                <tr v-for="(discipline, index) in gridTemplate" :key="index">
                  <td style="padding-left: 2px;">{{ index }}</td>

                  <template v-for="(stage) in discipline" >
                    <!-- eslint-disable-next-line vue/require-v-for-key -->
                    <td>
                      <input
                        type="text"
                        class="form-control"
                        @input="filterNonNumeric"
                        :value="!stage.workload ? '***' : stage.workload"
                        :disabled="!stage.workload ? true : false"
                      />
                    </td>

                    <!-- eslint-disable-next-line vue/require-v-for-key -->
                    <td>
                      <TheMask
                        type="text"
                        class="form-control"
                        :value="!stage.workload ? '***' : getGradeByInput(stage.stage_id, stage.discipline_id, teamId)"
                        :name="'grade[' + item.id + '][' + stage.stage_id + '][' + stage.discipline_id + '][' + teamId + ']'"
                        :mask="['#.#', '##.#']"
                        :disabled="!stage.workload ? true : false"
                        :masked="true"
                        :placeholder="!stage.workload ? '***' : '0.0'"
                      />
                    </td>

                  </template>

                </tr>
              </tbody>
            </table>

            <div class="form-group text-center my-2">
              <button type="submit" class="btn btn-success btn-sm" id="btnSaveGrades">SALVAR NOTAS NO HISTÓRICO</button>
            </div>
            <button class="btn btn-sm text-uppercase btn-secondary" @click="$router.go(-1)" id="btnBack">
                VOLTAR
              </button>
          </form>

          <div class="historyFooter text-center">
            <p>
              <b> {{ concatenateWithCommaAnd(rangeStage) }} Etapa(s)</b>
            </p>
            <p>CARGA HORÁRIA TOTAL: {{ totalWorkload }} HORAS AULAS</p>
            <p>Observação: A média de aprovação por disciplina é {{ media }}</p>
            <p>
              {{ city }} - {{ uf }}, {{ day }} de {{ month }} de {{ year }}.
            </p>
          </div>
        </div>
        <!-- ./ pdfContent -->
        <div class="form-group text-center my-2">
          <div class="form-check d-inline-block mr-3">
            <input
              class="form-check-input"
              type="checkbox"
              id="chkWithBackground"
              v-model="withBackground"
            />
            <label class="form-check-label" for="chkWithBackground">
              Imprimir com fundo
            </label>
          </div>
          <button
            @click="makePDF"
            :disabled="loading"
            class="btn btn-success btn-sm"
          >
            <span v-if="loading">Gerando...</span>
            <span v-else>GERAR DOCUMENTO EM PDF</span>
          </button>
        </div>
      </div>

      <div v-else>

        <button v-if="blobPDF" class="btn btn-sm btn-danger my-2" @click="destroyPDF">APAGAR HISTÓRICO</button>

        <iframe :src="blobPDF" 
        width="100%" 
        height="680" 
        style="border: none;"
        >
        </iframe>
        
      </div>

    </transition>

  </section>
</template>

<script>
import api from "@/services";
import LoadingPage from "@/components/LoadingPage.vue";
import { filterNonNumeric, generateHash, cpfWithMask, slug, documentStorageUrl } from "@/helpers";
import StatesMixin from "@/mixins/StatesMixin";

export default {
  mixins: [StatesMixin],
  name: "HistoryRegister",
  props: ["student"],
  components: { LoadingPage },
  data() {
    return {
      grades: [],
      filterNonNumeric,
      generateHash,
      cpfWithMask,
      slug,
      folder: "history",
      teamId: null,
      teamName: "",
      blobPDF: null,
      loading: false,
      item: null,
      attachments: [],
      typeDocument: "HISTORIC",
      city: "",
      day: new Date().getDate(),
      month: "",
      year: new Date().getFullYear(),
      media: 6,
      mediaOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      uf: "PA",
      teams: [],
      registrations: [],
      gridTemplate: {},
      courseName: "",
      totalStage: 0,
      totalWorkload: 0,
      stagesNumbers: 0,
      author: "",
      code: "",
      registration: "",
      selectedTemplateId: "",
      documentTemplates: [],
      generatedFilePath: "",
      withBackground: true,
      observation: "",
    };
  },
  filters: {
    uppercase(value) {
      if (!value) return "";
      return value.toString().toUpperCase();
    },
  },
  computed: {
    isObjectEmpty() {
      return Object.keys(this.gridTemplate).length !== 0;
    },
    rangeStage() {
      return this.stagesNumbers;
    },
    newNameFile() {
      return `${this.registration}_${this.item.cpf}_${this.slug(this.teamName).toUpperCase()}`;
    },
    fileFound() {
      const generatedFiles = this.attachments.filter((e) =>
        e.file_name.includes(`${this.item.cpf}_${this.slug(this.teamName).toUpperCase()}`)
      );
      return generatedFiles.length ? generatedFiles[0].file_name : "";
    },
  },
  methods: {
    getGradeByInput(stageId, disciplineId, teamId) {
      if (!this.grades.length) return;
      const gradeFiltered = this.grades.filter(
        (grade) =>
          grade.stage_id == stageId &&
          grade.discipline_id == disciplineId &&
          grade.team_id == teamId
      );
      return gradeFiltered.length ? gradeFiltered[0].grade : "0.0";
    },
    async getGradeByStudent() {
      const record = await api.get(
        `/grades/${this.student}/get-grade-by-student?`,
        { responseType: "json" }
      );
      this.grades = record.data;
    },
    async saveGrades() {
      const formData = new FormData(this.$refs.formHistoric);
      try {
        const result = await api.post(`/grades`, formData);
        Toast.fire("Mensagem", result.data.message, "success");
      } catch (error) {
        Toast.fire("Error", error.response.data.message, "error");
      }
    },
    async destroyPDF() {
      api
        .get(`/documents/${this.folder}/${this.fileFound}/remove`)
        .then((response) => {
          this.blobPDF = null;
          this.generatedFilePath = "";
          document.querySelector("select").value = "";
          Toast.fire(response.data.message, "", "success");
        })
        .catch((error) => {
          Toast.fire(error.response.data.message, "", "error");
        });
    },
    async makePDF() {
      if (!this.teamId || !this.selectedTemplateId) {
        return Toast.fire(
          "Erro",
          "Selecione a turma e o modelo do documento.",
          "error"
        );
      }

      this.loading = true;

      try {
        const payload = {
          student_id: this.item.id,
          team_id: this.teamId,
          template_id: this.selectedTemplateId,
          extra: {
            totalWorkload: this.totalWorkload,
            averageGrade: this.media,
            withBackground: this.withBackground,
            observation: this.observation,
            city: this.city,
            uf: this.uf,
            day: this.day,
            month: this.month,
            year: this.year,
          },
        };

        const response = await api.post("/exports/generate-document", payload);
        const { folder, file_name } = response.data.data;

        this.generatedFilePath = `${folder}/${file_name}`;

        Toast.fire("Sucesso", "Histórico gerado!", "success");

        this.$router.push({
          name: "student-edit",
          params: { id: this.item.id },
          query: { tab: "documentos" },
        });
      } catch (error) {
        const message =
          error.response?.data?.message || "Erro ao gerar o histórico.";
        Toast.fire("Erro", message, "error");
      } finally {
        this.loading = false;
      }
    },
    async loadPDF(folder, fileName) {
      await api
        .get(documentStorageUrl(folder, fileName), {
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          this.blobPDF = URL.createObjectURL(blob);
        });
    },
    async getItem() {
      await api.get(`/students/${this.student}`).then((res) => {
        this.attachments = res.data[0].documents.filter(
          (e) => e.type == this.typeDocument
        );
        this.item = res.data[0];
        this.teams = this.item.teams;
        this.registrations = this.item.registrations;
      });
    },
    async hasDocument(filename) {
      this.blobPDF = null;
      let bool = true;
      await api
        .get(documentStorageUrl(this.folder, filename), {
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          this.blobPDF = URL.createObjectURL(blob);
        })
        .catch(() => (bool = false));
      return bool;
    },
    async getFullGrid(ev) {
      this.gridTemplate = {};

      const { target, currentTarget } = ev;
      const selectedIndex = target.options.selectedIndex;

      this.registration = target.options[selectedIndex].dataset.matricula;
      this.teamName = target.options[selectedIndex].text;
      this.teamId = currentTarget.value;

      const isShowHistoryPDF = await this.hasDocument(this.fileFound);
      if (isShowHistoryPDF) return;
      else await this.getGridTemplate(this.teamId);
    },
    async getGridTemplate(team) {
      await api.get(`/grids/${team}/get-full-grid`).then((res) => {
        if (res.data.hasOwnProperty("list")) {
          const { list, course_name, total_stage, total_workload, stagesNumbers } = res.data;
          this.gridTemplate = list;
          this.courseName = course_name;
          this.totalStage = total_stage;
          this.totalWorkload = total_workload;
          this.stagesNumbers = stagesNumbers;
        } else {
          this.gridTemplate = {};
        }
      });
    },
    async getDocumentTemplates() {
      await api.get("/document-templates?perPage=100").then((res) => {
        this.documentTemplates = (res.data.data || []).filter(
          (t) => t.active && t.type === "history"
        );
      });
    },
    concatenateWithCommaAnd(arr) {
      if (arr.length === 0) return "";
      if (arr.length === 1) return arr[0];
      const lastItem = arr[arr.length - 1];
      const otherItems = arr.slice(0, arr.length - 1).join("ª, ");
      return `${otherItems}ª e ${lastItem}ª`;
    },
  },
  mounted() {
    this.getItem();
    this.code = this.generateHash("HIST_");
    this.getGradeByStudent();
    this.getDocumentTemplates();

    const dataClient = JSON.parse(localStorage.getItem("data_client") || "{}");
    const { school_name, average_grade, city } = dataClient;

    this.author = school_name || this.author;
    if (average_grade && this.mediaOptions.includes(Number(average_grade))) {
      this.media = Number(average_grade);
    }
    this.city = city || this.city;
    this.month = this.months[new Date().getMonth()];
  },
};
</script>

<style scoped>
[readonly] {
  background-color: #eee;
}
.v-enter,
.v-leave-to {
  opacity: 0;
}
.v-enter {
  transform: translate3d(0, -20px, 0);
}
</style>
